import { cellStickPositionFinder } from "./TableUtils";
import { staticValueFinder } from "../HelperFunctions";
import ActionsCellPlain from "./ActionsCellPlain";
import { Tooltip } from "@material-ui/core";
import { TooltipWrapper } from "../../../../../../Common/Utils/common_utils";
import { partnerTypeFields } from "./BodyEditCell";

const BodyCellPlain = (props) => {
  const { stickRight, stickLeft, cell, table, row } = props;
  const {
    componentType,
    id: columnId,
    customComponentKey,
  } = cell.column.columnDef;
  const isEditCell = columnId === "edit";
  const staticFinderParams = [componentType, cell];
  if (componentType === "customComponent") {
    staticFinderParams.push(customComponentKey);
  }
  const renderValue = staticValueFinder(...staticFinderParams);
  /**
   * ///////////Disabled fields based on Partner type /////////
   */
  const partnerTypesItems = row?.original?.PartnerProfile_type_of_partner?.map(
    (item) => {
      if (item.value && Object.keys(partnerTypeFields)?.includes(item.value)) {
        return item.value;
      }
    }
  );
  const filterItem = Object.keys(partnerTypeFields)?.filter(
    (item) => !partnerTypesItems?.includes(item)
  );
  let disableKeys = [];
  filterItem?.forEach((item) => {
    disableKeys = disableKeys?.concat([...partnerTypeFields[item]]);
  });
  //** */
  return (
    <td
      key={columnId + cell.row.id}
      className='live-view-body-cell-container'
      style={{
        ...cellStickPositionFinder(
          (stickRight && "right") || (stickLeft && "left") || ""
        ),
        zIndex: stickLeft || stickRight ? 9 : 8,
      }}
    >
      <div
        className='live-view-body-cell'
        style={{
          width: columnId === "edit" ? "8rem" : "11rem",
          borderLeft: columnId === "edit" ? "2px solid silver" : "",
          borderRight: stickLeft ? "2px solid silver" : "",
        }}
      >
        <>
          {!isEditCell ? (
            disableKeys?.includes(columnId) ? (
              "Disabled"
            ) : (
              renderValue || (
                <span style={{ width: "100%", textAlign: "center" }}> -</span>
              )
            )
          ) : (
            <ActionsCellPlain table={table} row={row} />
          )}
        </>
      </div>
    </td>
  );
};

export default BodyCellPlain;
